"use strict"

var $script = require('scriptjs');

/*
    DEFINE FUNCTIONS GENERAL
*/
var $ = jQuery;

const host = typeof jsData !== "undefined" ? jsData.assetsUrl : '';

const scripts = {
    'video': {
        url: 'https://cdnjs.cloudflare.com/ajax/libs/plyr/3.5.6/plyr.min.js.map',
        loaded: false,
    },
    'matchheight': {
        url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.2/jquery.matchHeight-min.js',
        loaded: false,
    },
    'imagesloaded' : {
        url: 'https://unpkg.com/imagesloaded@4.1.4/imagesloaded.pkgd.min.js',
        loaded: false,
    },
    'masonry': {
        url: 'https://unpkg.com/masonry-layout@4.2.2/dist/masonry.pkgd.min.js',
        loaded: false,
        dependancies: ['imagesloaded']
    },
    'intersection' : {
        url: 'https://cdn.jsdelivr.net/npm/intersection-observer@0.7.0/intersection-observer.js',
        loaded: false,
    },
    'lazy-load': {
        url: 'https://cdn.jsdelivr.net/npm/vanilla-lazyload@12.3.0/dist/lazyload.min.js',
        loaded: false,
        dependancies: ['intersection']
    },
    'fancyboxMousewheel': {
        url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js',
        loaded: false
    },
    'fancyboxPack': {
        url: 'https://cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.7/js/jquery.fancybox.min.js',
        loaded: false,
        dependancies: ['fancyboxMousewheel']
    },
    'lightbox': {
        url: 'https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js',
        loaded: false,
    },
}

const VIEW_PORT = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
   
};

const BREAK_POINT = {
    0: VIEW_PORT.SMALL,
    768: VIEW_PORT.MEDIUM,
    1025: VIEW_PORT.LARGE,
}

const viewport = () => {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

const getViewPort = (key) => {
    return VIEW_PORT[key] || '';
}

const detectViewPort = breakpoint => {
    let vWidth = viewport()['width'];
    var vp = ''

    Object.keys(breakpoint).forEach(key => {
        if (vWidth >= key) {
            vp = breakpoint[key];
        }
    });
    return vp;
}

const message = message => {
    if (typeof console.log !== "undefined") {
        console.log(message);
    }
}

const loadScript = (script, callback) => {
    if (script.loaded) {
        if (typeof callback === 'function') {
            callback();
        }
        return;
    } else {
        $.ajax({
            url: script.url,
            dataType: 'script',
            cache: true, // or get new, fresh copy on every page load
            success: function (data) {
                script.loaded = true;
                // message(`${script.url} is success`);
                if (script.type === 'css') {
                    jQuery("head").append('<style type="text/css">' + data + '</style>');
                }
                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
        return;
    }
}

const addScript = (list, key, callback) => {
    let script = list[key] || false;
    let count = 0;
    if (!script) {
        return;
    }
    if (typeof script.dependancies !== "undefined" && script.dependancies.length > 0) {
        script.dependancies.forEach(scr => {
            if (typeof list[scr] != "undefined") {
                addScript(list, scr, function () {
                    if (count == script.dependancies.length - 1) {
                        loadScript(script, callback);
                    }
                    count++;
                });
            }
        });
        return;
    } else {
        loadScript(script, callback);
    }
}

/*
    container (jQuery element): parent of items Ex: .list .list-item => container is ".list"
    itemClass (String): class of item EX: .list-item
    elClassNeed (Array): elements need make same height  Ex: ['h2', '.description', ...]
*/
function makeSameHeight(container, itemClass, elClassNeed)
{

    var container = jQuery(container);
    var itemClass = itemClass || '';
    var elClassNeed = elClassNeed || [];

    if (itemClass != "" && elClassNeed.length > 0) {
        var items = container.find(itemClass);
        var containerW = container.outerWidth();
        var totalItemW = 0;
        var maxH = {};
        var argsElement = [];

        //set default height
        jQuery.each(elClassNeed, function (index, c) {
            maxH[c] = {
                height: 0
            };
        });

        jQuery.each(items, function (index, item) {
            jQuery.each(elClassNeed, function (index, c) {
                jQuery(item).find(c).height('');
            });
        });

        jQuery.each(items, function (index, item) {
            totalItemW += jQuery(item).outerWidth(true);
            argsElement.push(item);

            /* find max height */
            jQuery.each(elClassNeed, function (index, c) {
                var h = jQuery(item).find(c).outerHeight();
                var mh = maxH[c].height;

                if (h > mh) {
                    maxH[c].height = h;
                }
            });
            //set max height
            if (Math.round(totalItemW) >= containerW) {
                jQuery.each(argsElement, function (index, el) {
                    jQuery.each(elClassNeed, function (index, c) {
                        jQuery(el).find(c).css({
                            height: maxH[c].height + 'px'
                        });
                    });
                });

                jQuery.each(elClassNeed, function (index, c) {
                    maxH[c] = {
                        height: 0
                    };
                });

                argsElement = [];
                totalItemW = 0;
            }
        });

        if (argsElement.length > 0) {
            jQuery.each(argsElement, function (index, el) {
                jQuery.each(elClassNeed, function (index, c) {
                    jQuery(el).find(c).css({
                        height: maxH[c].height + 'px'
                    });
                });
            });
        }
    }
}

const moving = () => {
    jQuery('.moving').each(function (index, el) {
        let mobile = jQuery(el).data('target-mobile') || '';
        let tablet = jQuery(el).data('target-tablet') || '';
        let pc = jQuery(el).data('target-pc') || '';

        switch (window.CURRENT_VIEW_PORT) {
            case VIEW_PORT.SMALL:
                if (mobile != '') {
                    jQuery(this).insertAfter($(mobile));
                }
                break;
            case VIEW_PORT.MEDIUM:
                if (tablet != '') {
                    jQuery(this).insertAfter($(tablet));
                }
                break;
            case VIEW_PORT.LARGE:
                if (pc != '') {
                    jQuery(this).insertAfter($(pc));
                }
                break;
        }
    });
}

/*
    sẽ trả về true when scroll vượt qua element
*/
const elementInScroll = elem => {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


/*
    kiểm tra element có tồn tại hay ko
*/
const checkExistElements = (selectors = []) => {
    let exist = false;
    if (selectors.length > 0) {
        selectors.forEach((value, index) => {
            if ($('body').find(value).length > 0) {
                exist = true;
                return true;
            }
        });
    }
    return exist;
}

/*
    Structure
        <div class="spacing" data-height='{"pc":"80px","tablet":"70px","mobile":"80px"}'></div>
*/
const spacing = () => {

    $('.spacing').each(function () {
        var h = $(this).data('height');

        if (window.CURRENT_VIEW_PORT == VIEW_PORT.SMALL) {
            $(this).css({
                'height': h.mobile
            });
        } else if (window.CURRENT_VIEW_PORT == VIEW_PORT.MEDIUM) {
            $(this).css({
                'height': h.tablet
            });
        } else if (window.CURRENT_VIEW_PORT == VIEW_PORT.LARGE) {
            $(this).css({
                'height': h.pc
            })
        }
    });
};

const viewportChange = () => {
    if (window.OLD_VIEW_PORT !== window.CURRENT_VIEW_PORT) {
        $(window).trigger('viewport-changed', [window.CURRENT_VIEW_PORT, window.OLD_VIEW_PORT]);
        window.OLD_VIEW_PORT = window.CURRENT_VIEW_PORT;
    }
}


//init view port
window.OLD_VIEW_PORT = '';
window.CURRENT_VIEW_PORT = detectViewPort(BREAK_POINT);

window.scripts = scripts;
window.checkExistElements = checkExistElements;
window.addScript = addScript;


(function () {
    $script(['https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/js/bootstrap.min.js'], 'bootstrap');

    $script.ready('bootstrap', () => {
        var time_show = $('#footer-popup').data('time')*1000;

        setTimeout(()=>{
            $('#footer-popup').modal({
                'backdrop':  false,
                'keyboard': false,
                'focus' : false,
                'show' : true
            });
        }, time_show); // Delay popup

    });
})();